/**
 * The MAX affordance on a funds field.
 *
 * There were three of these: two styled buttons that differed only in colour
 * and radius, and — in the spot deposit/withdraw modal — a styled `<span>`,
 * which no keyboard could reach and no screen reader announced as a control.
 * One component now, on the kit's own tokens, and always a real button.
 *
 * Disabled MAXes carry their reason as `title`, so "why can't I press this"
 * has an answer in the UI rather than only in the code.
 */
import styled from "styled-components";
import { FONT_CSS } from "../../../constants/design/fontSize";
import { FIELD_COLORS, PRIMARY_COLORS, TEXT_COLORS } from "../../../constants/design/colors";
import { BORDER_RADIUS, SPACING } from "../../../constants/design/spacing";

export const MaxButton = styled.button`
  ${FONT_CSS.label.three}
  background-color: ${FIELD_COLORS.two};
  color: ${TEXT_COLORS.two};
  border: none;
  border-radius: ${BORDER_RADIUS.sm}px;
  padding: ${SPACING.two}px ${SPACING.twoHalf}px;
  cursor: pointer;
  transition: color 80ms ease;

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    color: ${PRIMARY_COLORS.one};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
